import { ContextApi } from 'contexts/Localization/types'
import { PageMeta } from './types'

export const DEFAULT_META: PageMeta = {
  title: 'SolepeleusDEX',
  description: 'An evolving AMM on BSC! Powered by Solepeleus. Participate in farming, staking, offerings, and more.',
  image: 'https://dex.solepeleus.min.studio/images/hero.png',
}

export const getCustomMeta = (path: string, t: ContextApi['t']): PageMeta => {
  let basePath
  if (path.startsWith('/swap')) {
    basePath = '/swap'
  } else if (path.startsWith('/add')) {
    basePath = '/add'
  } else if (path.startsWith('/remove')) {
    basePath = '/remove'
  } else if (path.startsWith('/teams')) {
    basePath = '/teams'
  } else if (path.startsWith('/voting/proposal') && path !== '/voting/proposal/create') {
    basePath = '/voting/proposal'
  } else if (path.startsWith('/nfts/collections')) {
    basePath = '/nfts/collections'
  } else if (path.startsWith('/nfts/profile')) {
    basePath = '/nfts/profile'
  } else if (path.startsWith('/pancake-squad')) {
    basePath = '/pancake-squad'
  } else {
    basePath = path
  }

  switch (basePath) {
    case '/swap':
      return {
        title: `${t('Exchange')} | SolepeleusDEX`,
      }
    case '/add':
      return {
        title: `${t('Add Liquidity')} | SolepeleusDEX`,
      }
    case '/remove':
      return {
        title: `${t('Remove Liquidity')} | SolepeleusDEX`,
      }
    case '/liquidity':
      return {
        title: `${t('Liquidity')} | SolepeleusDEX`,
      }
    case '/find':
      return {
        title: `${t('Import Pool')} | SolepeleusDEX`,
      }
    default:
      return null
  }
}
